export default "__VITE_ASSET__2689a102__"